import React, { Suspense, useEffect } from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  RouteProps,
  useLocation,
  useNavigate,
} from 'react-router-dom'
import App from '@/app'
import { traverseTree } from '@/utils/utils'
import { isInWeChat } from '@/utils/common-js'
import { ENV } from '@/env'
import { useAdChannelStore } from '@/store/adChannelCode.store'
// 页面加载中组件
// import LoadingPage from '@/components/loading-page/loading-page'
// 首页
const Index = React.lazy(() => import('@/pages/index/index'))

// 登录页面
const Login = React.lazy(() => import('@/pages/login/login'))
// 注册页面
const Register = React.lazy(() => import('@/pages/register/register'))
// 领取额度
const GetQuota = React.lazy(() => import('@/pages/get-quota/get-quota'))
// 元信大额，填写资料
const FillInformation = React.lazy(() => import('@/pages/fill-information/fill-information'))
const NewFillInformation = React.lazy(() => import('@/pages/new-fill-infomation/new-fill-information'))
const FillInformationSuccess = React.lazy(() => import('@/pages/fill-information/components/success/success'))

// api回调授权成功中转页
const FillInformationSuccessTransfer = React.lazy(() => import('@/pages/fill-information/components/success/components/transfer/transfer'))

// 授权页
const FillInformationCommonAuthorize = React.lazy(() => import('@/pages/fill-information/components/authorize-commom-page/authorize-commom-page'))
// 提交表单后过渡动画页
const FillInformationCommonSubmitWaiting = React.lazy(() => import('@/pages/fill-information/components/submit-waiting/submit-waiting'))
// 用户重新匹配机构过渡页
const RematchWaiting = React.lazy(() => import('@/pages/fill-information/components/rematch-waiting/rematch-waiting'))
// 点击H5广告后跳转的授权页
const JointAuthLogin = React.lazy(() => import('@/pages/fill-information/components/joint-auth-login/joint-auth-login'))
// 审核新闻页面
const AuditNew = React.lazy(() => import('@/pages/audit-new/audit-new'))
// 审核新闻详情页面
const AuditNewDetail = React.lazy(() => import('@/pages/audit-new/components/detail/detail'))
// 隐私协议
const PrivacyAgreement = React.lazy(() => import('@/components/privacy-agreement/privacy-agreement'))
// 注册协议
const RegisterAgreement = React.lazy(() => import('@/components/register-agreement/register-agreement'))
// 注册协议
const InformationAgreement = React.lazy(() => import('@/components/infomation-agreement/information-agreement'))
// 个人信息授权书
const InfoAuditAgreement = React.lazy(() => import('@/components/info-audit-agreement/info-audit-agreement'))
// 有钱来默认联登协议
const DefaultUnionLoginAgreement = React.lazy(() => import('@/components/default-union-login-agreement/default-union-login-agreement'))
// 失效页面
const Failure = React.lazy(() => import('@/pages/failure/failure'))
const InstallPage = React.lazy(() => import('@/pages/app-install/app-install'))

// 表单流程3.0
const FillInformationThree = React.lazy(() => import('@/pages/fill-infomation-three/fill-information-three'))
// 表单流程3.0-加载动画
const LoadingPage = React.lazy(() => import('@/pages/fill-infomation-three/components/loading-page/loading-page'))
// 表单流程3.0-授权页
const FillInformationThreeAuthorize = React.lazy(() => import('@/pages/fill-infomation-three/components/authorize-commom-page-three/authorize-commom-page-three'))
// 表单流程3.0-授权页挽留页面
const RetainPage = React.lazy(() => import('@/pages/fill-infomation-three/components/retain-page/retain-page'))
// 表单流程3.0-结果页
const FillInformationThreeResult = React.lazy(() => import('@/pages/fill-infomation-three/components/success-page/success-page'))
// 二次匹配授权页面
const SeconedAuthorizePage = React.lazy(() => import('@/pages/seconed-authorize-page/seconed-authorize-page'))

// 授信表单流程
// 身份证校验
const IdentityVerification = React.lazy(() => import('@/pages/credit-process/identity-verification/identity-verification'))
// 人脸识别 loading
const FaceVerificationLoading = React.lazy(() => import('@/pages/credit-process/face-verification-loading/face-verification-loading'))
// 授信表单
const CreditApplicationForm = React.lazy(() => import('@/pages/credit-process/credit-application-form/credit-application-form'))
const CreditPersonalInformation = React.lazy(() => import('@/pages/credit-process/credit-personal-information/credit-personal-information'))
const LowValueCreditInformation = React.lazy(() => import('@/pages/credit-process/low-value-credit-information/low-value-credit-information'))
const CreditPersonalLoading = React.lazy(() => import('@/pages/credit-process/credit-personal-loading/credit-personal-loading'))
const CreditHalfProcessAuthorize = React.lazy(() => import('@/pages/credit-process/half-process-authorize/half-process-authorize'))
const FillInfomationFourMain = React.lazy(() => import('@/pages/fill-infomation-four/fill-infomation-four'))
const FillInfomationChengyi = React.lazy(() => import('@/pages/fill-infomation-chengyi/fill-infomation-chengyi'))

const FillInfomationFourProxy = (props: any) => {
  const channelValue = useAdChannelStore(state => state.channelValue)
  if (channelValue.includes('chengyitongTheme')) {
    return <FillInfomationChengyi {...props} />
  }
  return <FillInfomationFourMain {...props} />
}
const FillInfomationFive = React.lazy(() => import('@/pages/fill-infomation-five/fill-infomation-five'))
const FillInfomationFiveMatch = React.lazy(() => import('@/pages/fill-infomation-five/components/fill-infomation-match-product/fill-infomation-match-product'))
const FillInfomationFiveAuthorize = React.lazy(() => import('@/pages/fill-infomation-five/components/authorize-five/authorize-five'))
const ServiceAuthorizationAgreement = React.lazy(() => import('@/components/service-authorization-agreement/service-authorization-agreement'))
const EnterpriseTransition = React.lazy(() => import('@/pages/register/components/enterprise-transition/enterprise-transition'))
const CrmForm = React.lazy(() => import('@/pages/crm-form/crm-form'))
const RouteCodeUnitedLogin = React.lazy(() => import('@/pages/route-code-united-login/route-code-united-login'))
const EnterpriseRegister = React.lazy(() => import('@/pages/register/components/enterprise-register/enterprise-register'))
const ManualCustomerForm = React.lazy(() => import('@/pages/manual-customer-entry/manual-customer-form/manual-customer-form'))
const ManualCustomerAuthorize = React.lazy(() => import('@/pages/manual-customer-entry/manual-customer-authorize/manual-customer-authorize'))
const ManualCustomerResult = React.lazy(() => import('@/pages/manual-customer-entry/manual-customer-result/manual-customer-result'))

// 申请借款
const LoanApplication = React.lazy(() => import('@/pages/loan-application/loan-application'))
// 个人资料
const PersonalData = React.lazy(() => import('@/pages/my/components/personal-data/personal-data'))
// 申请记录
const ApplicationRecord = React.lazy(() => import('@/pages/my/components/application-record/application-record'))
// 内嵌页
const InLinePage = React.lazy(() => import('@/pages/inline-page/inline-page'))
// 下载应用
const Install = React.lazy(() => import('@/pages/register/components/app-install/app-install'))

// 测试页面
const Test = React.lazy(() => import('@/pages/test/test'))
const MiniProgram = React.lazy(() => import('@/pages/mini-program/mini-program'))

// CRM员工登录页
const CrmLogin = React.lazy(() => import('@/pages/crm-login/crm-login'))

// 上游协议填充页
const ProtocolFillInformation = React.lazy(() => import('@/pages/protocol-fill-information/protocol-fill-information'))

// 从马甲包跳转过来需展示的广告页
const Advertising = React.lazy(() => import('@/pages/yqzs-app/advertising/advertising'))
// 借款
const BorrowMoney = React.lazy(() => import('@/pages/yqzs-app/borrow-money/borrow-money'))
// 我的
const My = React.lazy(() => import('@/pages/yqzs-app/my/my'))
// 申请记录
const SafeCenter = React.lazy(() => import('@/pages/yqzs-app/my/components/safe-center/safe-center'))
// 注销账号
const CancelAccount = React.lazy(() => import('@/pages/yqzs-app/my/components/safe-center/components/cancel-account/cancel-account'))

// 从马甲包跳转过来需展示的360渠道专属页面

export interface MenuRoute {

  /** 标题 */
  title?: string,

  /** 是否要求登录 */
  requireLogin?: boolean,

  /** 是否不在菜单中显示 */
  hideInMenu?: boolean,

  /** 路由参数 */
  routeProps: RouteProps,

  /** 子菜单 */
  children?: MenuRoute[],

  /** 菜单图标 */
  icon?: string,

  /** 父级菜单对象 */
  parent?: MenuRoute | null,

  /** 完整路径 */
  fullPath?: string,

  /** 是否使用菜单栏布局 */
  hasMainLayout?: boolean,
}

export const routes: MenuRoute[] = [
  {
    routeProps: {
      path: '/',
      element: <App />,
    },
    children: [
      /** ============== 有钱助手模块 ============== */
      {
        routeProps: {
          index: true,
          element: <InstallPage />
        },
        title: '首页',
        // hasMainLayout: true
      },
      {
        routeProps: {
          path: 'my',
        },
        children: [
          {
            routeProps: {
              index: true,
              element: <My />
            },
            title: '我的',
            hasMainLayout: true,
          },
          {
            routeProps: {
              path: 'personal-data',
              element: <PersonalData />
            },
          },
          {
            routeProps: {
              path: 'application-record',
              element: <ApplicationRecord />
            }
          },
          {
            routeProps: {
              path: 'safe-center',
              element: <SafeCenter />
            },
          },
          {
            routeProps: {
              path: 'cancel-account',
              element: <CancelAccount />
            }
          }
        ]
      },
      {
        routeProps: {
          path: 'login',
          element: <Login />
        },
        title: '登录',
      },
      {
        routeProps: {
          path: 'loan-application',
          element: <LoanApplication />
        },
        title: '申请借款'
      },
      {
        routeProps: {
          path: 'inline-page',
          element: <InLinePage />
        },
        title: ''
      },
      {
        routeProps: {
          path: 'audit-new',
        },
        title: '每日新闻',
        children: [
          {
            routeProps: {
              index: true,
              element: <AuditNew />
            },
            title: '每日新闻'
          },
          {
            routeProps: {
              path: 'detail',
              element: <AuditNewDetail />
            },
            title: '每日新闻'
          }
        ]
      },
      // 有钱助手首页模块
      {
        routeProps: {
          path: 'advertising',
          element: <Advertising />,
        },
        title: '有钱助手',
        hasMainLayout: true
      },
      {
        routeProps: {
          path: 'borrow-money',
          element: <BorrowMoney />
        },
        title: '借款',
        hasMainLayout: true
      },

      /** ============== 有钱钱包 H5 模块 ============== */
      {
        routeProps: {
          path: 'register',
        },
        title: '有钱钱包',
        children: [
          {
            routeProps: {
              index: true,
              element: <Register />
            },
            title: '有钱钱包'
          },
          {
            routeProps: {
              path: 'success',
              element: <Install />
            },
            title: '有钱钱包'
          }
        ]
      },
      { // 领取额度 -- 在用
        routeProps: {
          path: 'getQuota',
          element: <GetQuota />,
        },
        title: '有钱钱包'
      },
      {
        routeProps: {
          path: 'manual-customer-entry'
        },
        title: '客户资质录入',
        children: [
          {
            routeProps: {
              index: true,
              element: <ManualCustomerForm />
            },
            title: '客户资质录入'
          },
          {
            routeProps: {
              path: 'authorize',
              element: <ManualCustomerAuthorize />
            },
            title: '产品匹配'
          },
          {
            routeProps: {
              path: 'result',
              element: <ManualCustomerResult />
            },
            title: '提交结果'
          }
        ]
      },
      // 企业过渡页
      {
        routeProps: {
          path: 'enterprise-transition',
          element: <EnterpriseTransition />,
        },
        title: '有钱钱包'
      },
      {
        routeProps: {
          path: 'enterprise-register',
          element: <EnterpriseRegister />,
        },
        title: '有钱钱包'
      },

      // 聚客融需要用/h5?source=BryFpJ来访问注册页面
      {
        routeProps: {
          path: 'h5',
          element: <GetQuota />,
        },
        title: '有钱钱包'
      },
      {
        routeProps: {
          path: 'fill-information', // -- 在用
        },
        title: '填写资料',
        children: [
          {
            routeProps: {
              index: true,
              element: <FillInformation />
            },
            title: '填写资料'
          },
          {
            routeProps: {
              path: 'success',
              element: <FillInformationSuccess />
            },
            title: '审核成功'
          },
          {
            routeProps: {
              path: 'common-authorize',
              element: <FillInformationCommonAuthorize />
            },
            title: '授权'
          },
          {
            routeProps: {
              path: 'waiting-result',
              element: <FillInformationCommonSubmitWaiting />
            },
            title: '匹配产品'
          },
          {
            routeProps: {
              path: 'joint-auth-login',
              element: <JointAuthLogin />
            },
            title: '授权'
          },
          {
            routeProps: {
              path: 'rematch-waiting',
              element: <RematchWaiting />
            },
            title: '有钱来'
          },
          {
            routeProps: {
              path: 'success-transfer',
              element: <FillInformationSuccessTransfer />
            },
            title: '有钱来'
          },
        ]
      },
      // 表单流程2
      {
        routeProps: {
          path: 'new-fill-information',
          element: <NewFillInformation />
        },
        title: '填写资料'
      },
      // 表单流程3
      {
        routeProps: {
          path: 'fill-information-three',
        },
        title: '填写资料',
        children: [
          {
            routeProps: {
              index: true,
              element: <FillInformationThree />
            },
            title: '填写资料'
          },
          {
            routeProps: {
              path: 'loading',
              element: <LoadingPage />
            },
            title: '加载'
          },
          {
            routeProps: {
              path: 'authorize-page-three',
              element: <FillInformationThreeAuthorize />
            },
            title: '授权'
          },
          {
            routeProps: {
              path: 'retain-page',
              element: <RetainPage />
            },
            title: '挽留'
          },
          {
            routeProps: {
              path: 'success-page',
              element: <FillInformationThreeResult />
            },
            title: '成功'
          }
        ]
      },
      // 表单流程 4 -- 在用
      {
        routeProps: {
          path: 'fill-information-four',
        },
        title: '资料填写',
        children: [
          {
            routeProps: {
              index: true,
              element: <FillInfomationFourProxy />
            },
            title: '填写资料'
          },
        ]
      },
      // 表单流程 5
      {
        routeProps: {
          path: 'fill-information-five',
        },
        title: '资料填写',
        children: [
          {
            routeProps: {
              index: true,
              element: <FillInfomationFive />
            },
            title: '填写资料'
          },
          {
            routeProps: {
              path: 'match',
              element: <FillInfomationFiveMatch />
            },
            title: '金融借款'
          },
          {
            routeProps: {
              path: 'authorize',
              element: <FillInfomationFiveAuthorize />
            },
            title: '金融借款'
          }
        ]
      },
      // 授信流程
      {
        routeProps: {
          path: 'credit-process',
        },
        title: '授信流程',
        children: [
          {
            routeProps: {
              path: 'identity-verification',
              element: <IdentityVerification />
            },
            title: '身份证校验'
          },
          {
            routeProps: {
              path: 'face-verification-loading',
              element: <FaceVerificationLoading />
            },
            title: '人脸识别加载'
          },
          {
            routeProps: {
              path: 'credit-personal-infomation',
              element: <CreditPersonalInformation />
            },
            title: '授信信息'
          },
          {
            routeProps: {
              path: 'low-value-credit-information',
              element: <LowValueCreditInformation />
            },
            title: '低产值授信信息'
          },
          {
            routeProps: {
              path: 'credit-personal-loading',
              element: <CreditPersonalLoading />
            },
            title: '授信加载'
          },
          {
            routeProps: {
              path: 'credit-application-form',
              element: <CreditApplicationForm />
            },
            title: '授信表单'
          },
          {
            routeProps: {
              path: 'half-process-authorize',
              element: <CreditHalfProcessAuthorize />
            },
            title: '审核结果'
          },
        ]
      },
      // 路由码联登
      {
        routeProps: {
          path: 'routeCode-unitedLogin',
          element: <RouteCodeUnitedLogin />
        },
        title: '路由码联登'
      },
      // 二次匹配授权
      {
        routeProps: {
          path: 'seconed-match-authorize',
          element: <SeconedAuthorizePage />
        },
        title: '有钱钱包'
      },
      // H5协议部分
      {
        // 注册协议
        routeProps: {
          path: 'register-agreement',
          element: <RegisterAgreement />
        },
        title: '有钱钱包'
      },
      {
        // 服务授权协议
        routeProps: {
          path: 'default-union-login-agreement',
          element: <DefaultUnionLoginAgreement />
        },
        title: '有钱钱包'
      },
      {
        // 注册协议
        routeProps: {
          path: 'service-authorization-agreement',
          element: <ServiceAuthorizationAgreement />
        },
        title: '有钱钱包'
      },
      {
        // 隐私协议
        routeProps: {
          path: 'privacy-agreement',
          element: <PrivacyAgreement />
        },
        title: '有钱钱包'
      },
      {
        // 个人信息共享授权协议
        routeProps: {
          path: 'information-agreement',
          element: <InformationAgreement />
        },
        title: '有钱钱包'
      },
      {
        // 个人信息授权
        routeProps: {
          path: 'info-audit-agreement',
          element: <InfoAuditAgreement />
        },
        title: '有钱钱包'
      },
      {
        // 协议
        routeProps: {
          path: 'protocol-fill-information',
          element: <ProtocolFillInformation />
        },
        title: '协议'
      },
      // 渠道码未开启页面
      {
        routeProps: {
          path: 'failure',
          element: <Failure />
        },
        title: '有钱钱包',
      },

      /** ============== CRM 认证模块 ============== */
      {
        // CRM登录
        routeProps: {
          path: 'crm-login',
          element: <CrmLogin />
        },
        title: 'CRM登录'
      },
      // crm 表单
      {
        routeProps: {
          path: 'crm-form',
          element: <CrmForm />,
        },
        title: 'CRM系统'
      },
    ]
  },
  {
    routeProps: {
      path: '/mini-program',
      element: <MiniProgram />,
    },
    title: '有钱钱包',
    hideInMenu: true,
  }
]

if (ENV.NODE_ENV === 'development') {
  routes[0].children?.push(...[
    {
      routeProps: {
        path: 'test',
        element: <Test />
      },
      title: '测试页面',
      hideInMenu: true
    }
  ])
}

// 打平的路由数组
export const flattenRoutes: MenuRoute[] = []
// 完整路径-路由对象 map
const routesMap: Record<string, MenuRoute> = {}
// 递归路由，添加页面权限控制和父节点、完整路径
traverseTree(routes, (route, parent) => {
  // if (route.requireLogin && route.routeProps.element) {
  //   route.routeProps.element = <PermissionRoute route={route}>{route.routeProps.element}</PermissionRoute>
  // }
  route.parent = parent
  // 完整路径
  let fullPath: string | undefined
  if (parent) {
    fullPath = route.routeProps.index ? parent.fullPath : `${(parent.fullPath || '').replace(/\/$/, '')}/${route.routeProps.path || ''}`
  } else {
    fullPath = route.routeProps.path
  }
  route.fullPath = fullPath
  flattenRoutes.push(route)
  if (fullPath) {
    routesMap[fullPath] = route
  }
})

// 获取某个路由对象
export const getRoute: (fullPath: string) => MenuRoute | null = function getRoute(fullPath) {
  return routesMap[fullPath] || null
}

function createRdParam() {
  const digit = Math.floor(Math.random() * 10)
  const letters = Array.from({ length: 4 })
    .map(() => String.fromCharCode(97 + Math.floor(Math.random() * 26)))
    .join('')
  const key = `rd${digit}${letters}`
  const value = `${key}${Date.now()}`
  return { key, value }
}

const NavigationInterceptor = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isInWeChat) return
    const injected = (location.state as any)?.__rdInjected
    if (injected) return

    const { key, value } = createRdParam()
    const sp = new URLSearchParams(location.search)
    sp.set(key, value)

    navigate(
      {
        pathname: location.pathname,
        search: `?${sp.toString()}`,
        hash: location.hash,
      },
      {
        replace: true,
        state: { ...(location.state as any), __rdInjected: true },
      }
    )
  }, [location, navigate])

  return null
}

const Router = () => {
  // 渲染路由组件
  const renderRoute = (route: MenuRoute) => {
    const children = route.children?.map(childMenu => renderRoute(childMenu))
    return <Route key={route.fullPath || '/'} {...route.routeProps}>{children}</Route>
  }
  return (
    // <Suspense fallback={ <LoadingPage />}>
    <Suspense>
      <BrowserRouter>
        <NavigationInterceptor />
        <Routes>
          {
            routes.map(renderRoute)
          }
        </Routes>
      </BrowserRouter>
    </Suspense>
  )
}

export default Router
